export default "__VITE_ASSET__CHCplOYR__"